export default "__VITE_ASSET__D1luuR2K__"